export default __webpack_public_path__ + "static/media/DaveStann-min.1eeda499.png";